const buildLandlordDataFetchObject = (applicantId, uData) => {
  const dataObject = {
    qdbapi: {
      udata: uData,
      clist: "32",
      ApplicantId: applicantId,
      fmt: "structured",
    },
  };

  if(uData == "TFA_RESUBMISSION_PAGE_GET_BANK_DATA") {
    dataObject.qdbapi.query = `{'10'.EX.'${applicantId}'}`;
  } else if(typeof applicantId == "number"){
    dataObject.qdbapi.query = `{'3'.EX.'${applicantId}'}`;
  } else if (applicantId) {
    dataObject.qdbapi.query = `{'62'.EX.'${applicantId}'}`;
  }
  return dataObject;
};

export default buildLandlordDataFetchObject;
